import "./styles/output.css";
import "./styles/layout.css";
import "./styles/index.scss";
import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { App } from "./App";
import { initLocalStorage } from "@/common/browserStorage/initLocalStorage";
import { utmController } from "@/common/utm/controller";

initLocalStorage();
utmController();

const rootElement = document.getElementById("root");

const ErrorBoundaryPage = lazy(() => import("@/pages/ErrorBoundaryPage"));
type RequestIdleCallback = (
  callback: () => void,
  options?: { timeout: number },
) => number;

const requestIdle = (
  window as Window & { requestIdleCallback?: RequestIdleCallback }
).requestIdleCallback;

const loadSentryWhenIdle = () => {
  const loadSentry = () => {
    void import("./sentry");
  };

  if (requestIdle) {
    requestIdle(loadSentry, { timeout: 5000 });
  } else {
    window.setTimeout(loadSentry, 2000);
  }
};

if (!rootElement) {
  console.warn("No #root element found — skipping React bootstrap.");
} else {
  const root = createRoot(rootElement!);
  root.render(
    <StrictMode>
      <ErrorBoundary
        FallbackComponent={(props) => (
          <Suspense fallback={null}>
            <ErrorBoundaryPage {...props} />
          </Suspense>
        )}
      >
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );

  loadSentryWhenIdle();
}
